import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SettingsInputHdmiIcon(props: IconProps) {
    return <Icon {...props} iconKey={"settings_input_hdmi"}/>
}
